import React from "react";

/**
 * Shared frame for the line-drawn menu icons (Leads, Proposals, Maintenance,
 * Work Orders, Locations, Mulch Calculator): the same props contract as
 * ClientsIcon (18 x 18 viewBox, `width` / `height` / `margin`, colour from
 * `fill`), with the colour applied as the stroke. `children` receives the
 * colour so an icon can also fill small dots with it.
 */
export function strokeIconStyle(props: any) {
  const svgStyles: any = {
    width: props?.width ? props.width : null,
    height: props?.height ? props.height : null,
    fill: props?.fill ? props.fill : null,
    margin: props?.margin ? props.margin : null,
  };
  return Object.keys(svgStyles)
    .filter((key) => svgStyles[key] !== null && svgStyles[key] !== undefined)
    .reduce((acc: any, key) => {
      acc[key] = svgStyles[key];
      return acc;
    }, {});
}

export default function StrokeIcon({
  iconProps,
  children,
}: {
  iconProps: any;
  children: (color: string) => React.ReactNode;
}) {
  const style = strokeIconStyle(iconProps);
  const color = style.fill ?? "currentColor";
  return (
    <svg
      viewBox="0 0 18 18"
      fill="none"
      style={{ ...style, fill: "none" }}
      className={iconProps?.className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g stroke={color} strokeWidth={1.1} strokeLinecap="round" strokeLinejoin="round" fill="none">
        {children(color)}
      </g>
    </svg>
  );
}
